import { lazy } from 'react'
import type { RoleKey } from '@workspace/ui'

const loadRemote = (role: RoleKey, importer: () => Promise<{ default: any }>) =>
  lazy(async () => {
    try {
      return await importer()
    } catch (error) {
      console.error(`[Dashboard] Failed to load remote for role ${role}`, error)
      throw error instanceof Error ? error : new Error(String(error))
    }
  })

// Registry mapping role keys to the appropriate app entry component.
// QB/ST expose EmbeddedApp for routerless embedding; others use their default export.
export const roleRegistry: Record<RoleKey, ReturnType<typeof lazy>> = {
  qb: loadRemote('qb', () => import('@remotes/qb').then((m) => ({ default: m.EmbeddedApp }))),
  st: loadRemote('st', () => import('@remotes/st').then((m) => ({ default: m.EmbeddedApp }))),
  wr: loadRemote('wr', () => import('@remotes/wr').then((m) => ({ default: m.EmbeddedApp }))),
  rb: loadRemote('rb', () => import('@remotes/rb').then((m) => ({ default: m.EmbeddedApp }))),
  lb: loadRemote('lb', () => import('@remotes/lb').then((m) => ({ default: m.EmbeddedApp }))),
  db: loadRemote('db', () => import('@remotes/db').then((m) => ({ default: m.EmbeddedApp }))),
  dl: loadRemote('dl', () => import('@remotes/dl').then((m) => ({ default: m.EmbeddedApp }))),
  dc: loadRemote('dc', () => import('@remotes/dc').then((m) => ({ default: m.EmbeddedApp }))),
  te: loadRemote('te', () => import('@remotes/te').then((m) => ({ default: m.EmbeddedApp }))),
  ol: loadRemote('ol', () => import('@remotes/ol').then((m) => ({ default: m.EmbeddedApp }))),
  s: loadRemote('s', () => import('@remotes/s').then((m) => ({ default: m.EmbeddedApp }))),
  def: loadRemote('def', () => import('@remotes/def').then((m) => ({ default: m.EmbeddedApp }))),
}
